module.exports = __webpack_public_path__ + "img/service-and-shop-filter-toyota.d6387fc8.jpg";